import s from "./td-longtail-vue-components179.js";
/* empty css                              */
import l from "./td-longtail-vue-components98.js";
var r = function() {
  var e = this, a = e._self._c, t = e._self._setupProxy;
  return t.energyDocumentList.length > 1 ? a(t.ListDropdown, { staticClass: "energy-label-datasheet", attrs: { options: t.energyDocumentList, "data-testid": "dropdown", placeholder: e.label }, on: { input: t.openNewTab } }) : t.singleItem ? a("div", { staticClass: "energy-label-datasheet", attrs: { "data-testid": "single" } }, [a(t.LinkButton, { staticClass: "energy-label-datasheet__button", style: `--label-color: ${e.labelColor}`, attrs: { tag: "button", text: "" }, nativeOn: { click: function(n) {
    return n.preventDefault(), t.openNewTab(t.singleItem.value);
  } } }, [e._v(" " + e._s(e.label) + " ")])], 1) : e._e();
}, o = [], i = /* @__PURE__ */ l(
  s,
  r,
  o,
  !1,
  null,
  "b0e9c840"
);
const u = i.exports;
export {
  u as default
};
